// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n/**\n* Colors\n*/\n.ant-form-item-label > label {\n  color: #262626; }\n\n.Form_item-size__2Tx4e > .Form_ant-row__Yha8C.Form_ant-form-item-row__2E-Pm {\n  min-width: 250px; }\n\n.Form_requiredMark__2aw08 {\n  color: #f05353;\n  margin-left: 5px; }\n\n.Form_hide__14KoW {\n  display: none; }\n\n.Form_tooltipOverlay__24y9I {\n  margin-bottom: 10px;\n  max-width: 330px; }\n  .Form_tooltipOverlay__24y9I .ant-tooltip-inner,\n  .Form_tooltipOverlay__24y9I .ant-tooltip-arrow-content {\n    background-color: #fff7e6; }\n  .Form_tooltipOverlay__24y9I .ant-tooltip-inner {\n    padding: 12px 16px 12px 10px; }\n\n.Form_formItem__RAoMh.Form_noMargin__3gXkv {\n  margin-bottom: 0 !important; }\n", ""]);
// Exports
exports.locals = {
	"item-size": "Form_item-size__2Tx4e",
	"ant-row": "Form_ant-row__Yha8C",
	"ant-form-item-row": "Form_ant-form-item-row__2E-Pm",
	"requiredMark": "Form_requiredMark__2aw08",
	"hide": "Form_hide__14KoW",
	"tooltipOverlay": "Form_tooltipOverlay__24y9I",
	"formItem": "Form_formItem__RAoMh",
	"noMargin": "Form_noMargin__3gXkv"
};
module.exports = exports;
